import React from "react";
import {
  Breadcrumb,
  Row,
  Col,
  Form,
  Input,
  Button,
  Select,
  DatePicker,
  message,
  Alert,
  Spin,
  Modal,
  Divider,
} from "antd";
import {
  CheckCircleOutlined,
  PrinterOutlined,
  InfoCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import moment from "moment";

import '../../assets/fiskal.css';
import Config from "../../Config";
import { connect } from "react-redux";
import {
  initHandler,
  ajaxViewHandler,
  ajaxHandler,
  setConfig,
} from "../../store/actions";
import { Helmet } from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';

const configClass = {
  title: "surat keterangan fiskal",
  apiUrl: {
    provinsi: "master/api/provinsi/",
    kabupaten: "master/api/kabupaten/",
    fiskal: "transaksi/api/tagihan/",
  },
  pageUrl: {
    cetak_no: "/addon/surat_fiskal/",
  },
  breadCrumb: [
    <span><InfoCircleOutlined /> informasi</span>,
    "surat keterangan fiskal",
  ],
};

const config = new Config();

class SuratKeteranganFiskal extends React.Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      errComponent: false,
      errTitle: "",
      errMsg: "",
      loadingButton: false,
      cari_no_pol: undefined,
      loadingData: false,
      loadingProvinsi: false,
      listProvinsi: [],
      listProvinsiAll: [],
      loadingKabupaten: false,
      listKabupaten: [],
      dataKendaraan: null,
      kode_tujuan: "1",
      printData: null,
      formAllFilled: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.initHandler();
  }

  componentDidMount() {
    this.loadAllProvinsi();
  }

  // ── Province loading & filtering ─────────────────────────────

  async loadAllProvinsi() {
    this.setState({ loadingProvinsi: true });
    this.props.ajaxViewHandler("get", configClass.apiUrl.provinsi + "?limit=999")
      .then(() => {
        const data = this.props.responseMsg;
        if (this.props.isSuccess) {
          const arr = data.results || (Array.isArray(data) ? data : []);
          this.setState({ listProvinsiAll: arr });
          this.filterAndSetProvinsi("1", arr);
        }
        this.setState({ loadingProvinsi: false });
      })
      .catch(() => this.setState({ loadingProvinsi: false }));
  }

  filterAndSetProvinsi(kode, all = this.state.listProvinsiAll) {
    let filtered;
    if (kode === "2") {
      // Exact match agar tidak salah ambil entry lain yang sekadar mengandung kata yang sama
      filtered = all.filter(
        p => p.name && p.name.toUpperCase().trim() === "KALIMANTAN TENGAH"
      );
    } else {
      filtered = all.filter(
        p => !p.name || p.name.toUpperCase().trim() !== "KALIMANTAN TENGAH"
      );
    }
    this.setState({ listProvinsi: filtered });
    return filtered;
  }

  handleKodeTujuanChange = (val) => {
    this.setState({ kode_tujuan: val || "1" });
    const filtered = this.filterAndSetProvinsi(val || "1");

    if (val === "2") {
      // API kabupaten menggunakan kode BPS provinsi Kalimantan Tengah = 62
      const KALTENG_API_PARAM = 62;
      // Cari province dari list untuk nilai Select (display)
      const kalteng = this.state.listProvinsiAll.find(
        (p) => p.name && p.name.toUpperCase().trim() === "KALIMANTAN TENGAH"
      );
      // Select pakai id province agar label nama tampil; API kabupaten tetap pakai 62
      const selectVal = kalteng ? kalteng.id : KALTENG_API_PARAM;
      // Kosongkan listKabupaten terlebih dahulu agar getMasterList tidak merge hasil lama
      this.setState({ listKabupaten: [] }, () => {
        this.formRef.current.setFieldsValue({
          provinsi_tujuan_nama: selectVal,
          kabupaten_tujuan: undefined,
        });
        this.loadKabupaten(KALTENG_API_PARAM);
      });
    } else {
      this.formRef.current.setFieldsValue({
        provinsi_tujuan_nama: undefined,
        kabupaten_tujuan: undefined,
      });
      this.setState({ listKabupaten: [] });
    }
  }

  handleProvinsiChange = (val) => {
    this.formRef.current.setFieldsValue({ kabupaten_tujuan: undefined });
    this.setState({ listKabupaten: [] });
    if (val) {
      this.loadKabupaten(this.resolveProvinsiApiParam(val));
    }
  }

  // Konversi province id database → kode BPS yang diterima API kabupaten.
  // Kalimantan Tengah: id database = 99, kode BPS (param API) = 62.
  resolveProvinsiApiParam(provinsiId) {
    const prov = this.state.listProvinsiAll.find((p) => p.id === provinsiId);
    if (prov && prov.name && prov.name.toUpperCase().trim() === "KALIMANTAN TENGAH") {
      return 62;
    }
    return provinsiId;
  }

  loadKabupaten(provinsiId) {
    this.getMasterList({
      destination: {
        stateProgressName: "loadingKabupaten",
        endPoint: configClass.apiUrl.kabupaten + "?province=" + provinsiId + "&fiskal=true",
        stateDestination: "listKabupaten",
      },
      nextDestination: null,
    });
  }

  // ── Generic master list loader ───────────────────────────────

  async getMasterList(rule, isFinal = false) {
    var destination = rule.destination;
    var nextDestination = rule.nextDestination;
    this.setState({ [destination.stateProgressName]: true });
    this.props
      .ajaxViewHandler("get", destination.endPoint)
      .then(() => {
        const data = this.props.responseMsg;
        if (this.props.isSuccess) {
          if (data.count != undefined) {
            let newState = null;
            if (this.state[destination.stateDestination].length == 0) {
              newState = data;
            } else {
              if (destination.stateProgressName.includes("_searching")) {
                newState = data;
              } else {
                const oldState = this.state[destination.stateDestination];
                newState = {
                  count: data.count,
                  next: data.next,
                  previous: data.previous,
                  results: [...oldState.results, ...data.results],
                };
              }
            }
            this.setState({ [destination.stateDestination]: newState });
          } else if (data.results != undefined) {
            this.setState({ [destination.stateDestination]: data.results });
          } else {
            if (Array.isArray(data)) {
              this.setState({ [destination.stateDestination]: data });
            } else {
              this.setState({ [destination.stateDestination]: [data] });
            }
          }
        } else {
          this.setState({ errComponent: true });
        }
        this.setState({ [destination.stateProgressName]: false });
      })
      .catch((response) => {
        message.error({ content: "gagal request data, coba lagi", duration: 2, key: "toast" });
        this.setState({ [destination.stateProgressName]: false });
      });
    if (nextDestination != null) {
      const next = {
        destination: {
          stateProgressName: nextDestination.stateProgressName,
          endPoint: nextDestination.endPoint,
          stateDestination: nextDestination.stateDestination,
        },
        nextDestination: nextDestination.next,
      };
      this.getMasterList(next);
    }
  }

  // ── Kabupaten select (generic) ───────────────────────────────

  generateKabupatenSelect() {
    const stateName = "Kabupaten";
    const url = configClass.apiUrl.kabupaten;
    return this.state.loadingKabupaten ? (
      <Spin size="small" />
    ) : (
      <Select
        showSearch
        placeholder="Cari / Pilih Kabupaten"
        optionFilterProp="children"
        onSearch={(val) => {
          const rule = {
            destination: {
              stateProgressName: "loadingKabupaten_searching",
              endPoint: url + "?search=" + val,
              stateDestination: "listKabupaten",
            },
            nextDestination: null,
          };
          this.getMasterList(rule);
        }}
        onPopupScroll={(e) => {
          e.persist();
          let target = e.target;
          if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            if (
              this.state.listKabupaten.next != undefined &&
              this.state.listKabupaten.next != null
            ) {
              const rule = {
                destination: {
                  stateProgressName: "loadingKabupatenPaging",
                  endPoint: this.state.listKabupaten.next,
                  stateDestination: "listKabupaten",
                },
                nextDestination: null,
              };
              this.getMasterList(rule);
            }
          }
        }}
        allowClear
        style={{ width: "100%" }}
        size="small"
      >
        {this.state.listKabupaten.count != undefined
          ? this.state.listKabupaten.results.map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.name}
              </Select.Option>
            ))
          : this.state.listKabupaten.map
          ? this.state.listKabupaten.map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.name}
              </Select.Option>
            ))
          : null}
        {this.state.listKabupaten != undefined &&
          this.state.listKabupaten.next != undefined && (
            <Select.Option value="">
              <Spin size="small" />
            </Select.Option>
          )}
      </Select>
    );
  }

  // ── Search kendaraan ─────────────────────────────────────────

  searchKendaraan = (no_polisi) => {
    this.previewData(no_polisi);
  };

  async previewData(no_polisi = "") {
    message.loading({ content: "Proses pencarian...", duration: 0, key: "toast" });
    this.setState({ errTitle: "", errMsg: "", dataKendaraan: null, loadingData: true });

    const url = configClass.apiUrl.fiskal + "?is_paid=true&nomor_polisi=KH" + no_polisi;

    this.props.ajaxViewHandler("get", url)
      .then(() => {
        const datas = this.props.responseMsg;
        if (this.props.isSuccess) {
          if (datas.results.length === 0) {
            message.error({ content: "nomor kendaraan tidak ditemukan", duration: 2, key: "toast" });
          } else {
            message.destroy();
            this.setState({ dataKendaraan: datas.results[0] });
            const data = datas.results[0];

            // Proses kode_tujuan LEBIH DULU agar filter provinsi siap sebelum loop
            if (data.kode_tujuan != null) {
              const kodeStr = String(data.kode_tujuan);
              this.formRef.current.setFieldsValue({ kode_tujuan: kodeStr });
              this.setState({ kode_tujuan: kodeStr });
              this.filterAndSetProvinsi(kodeStr);
            }

            // Track provinsi & kabupaten untuk dimuat setelah loop
            let savedProvinsiId = null;
            let savedKabupatenId = null;

            for (var key in data) {
              if (key === "kode_tujuan") continue; // sudah diproses di atas

              const dateRegex2 = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/;
              if (dateRegex2.test(data[key])) {
                this.formRef.current.setFieldsValue({
                  [key + "_picker"]: moment(data[key], "YYYY-MM-DD"),
                  [key]: moment(data[key]).format("DD-MM-YYYY"),
                });
              } else if (key === "pemilik_nama") {
                this.formRef.current.setFieldsValue({ nama: data[key] });
              } else if (key === "alamat_wp") {
                this.formRef.current.setFieldsValue({ alamat: data[key] });
              } else if (key === "merk_kendaraan") {
                this.formRef.current.setFieldsValue({ merek: data[key] });
              } else if (key === "tahun_buat") {
                this.formRef.current.setFieldsValue({ tahun: data[key] });
              } else if (key === "cc") {
                this.formRef.current.setFieldsValue({ silinder: data[key] });
              } else if (key === "bahan_bakar_nama") {
                this.formRef.current.setFieldsValue({ bahan_bakar: data[key] });
              } else if (key === "tipe_nama") {
                this.formRef.current.setFieldsValue({ tipe: data[key] });
              } else if (key === "nomor_polisi_tengah") {
                this.formRef.current.setFieldsValue({ no_polisi_tengah: data[key] });
              } else if (key === "nomor_polisi_akhir") {
                this.formRef.current.setFieldsValue({ no_polisi_belakang: data[key] });
              } else if (key === "stnk_akhir" && data[key] != null) {
                this.formRef.current.setFieldsValue({
                  [key + "_picker"]: moment(data[key]),
                  [key]: moment(data[key]).format("DD-MM-YYYY"),
                  tgl_akhir_swdkllj_picker: moment(data[key]),
                  tgl_akhir_swdkllj: moment(data[key]),
                });
              } else if (key === "stnk_mulai" && data[key] != null) {
                this.formRef.current.setFieldsValue({
                  [key + "_picker"]: moment(data[key]),
                  [key]: moment(data[key]).format("DD-MM-YYYY"),
                });
              } else if (
                (key === "tanggal_faktur" || key === "tanggal_kwitansi") &&
                data[key] != null
              ) {
                this.formRef.current.setFieldsValue({
                  [key + "_picker"]: moment(data[key]),
                  [key]: moment(data[key]).format("DD-MM-YYYY"),
                });
              } else if (key === "nama_tujuan") {
                if (data[key] != null) {
                  this.formRef.current.setFieldsValue({ nama_tujuan: data[key] });
                }
              } else if (key === "provinsi_tujuan_nama") {
                // API mengembalikan NAMA provinsi — cari di listProvinsiAll untuk dapat kode/id
                const namaProvinsi = (data[key] || "").toUpperCase().trim();
                const foundProv = this.state.listProvinsiAll.find(
                  (p) => p.name && p.name.toUpperCase().trim() === namaProvinsi
                );
                if (foundProv) {
                  // Set Select dengan id province (untuk display nama)
                  // savedProvinsiId dipakai untuk load kabupaten via API
                  savedProvinsiId = foundProv.id;
                  this.formRef.current.setFieldsValue({ provinsi_tujuan_nama: foundProv.id });
                }
              } else if (key === "kabupaten_tujuan") {
                // Catat ID kabupaten, JANGAN set dulu — opsi belum dimuat
                savedKabupatenId = data[key];
              } else {
                this.formRef.current.setFieldsValue({ [key]: data[key] });
              }
            }

            // Jika fiskal sudah pernah disimpan (ada nomor_surat), siapkan printData
            // sehingga tombol Cetak langsung muncul setelah form terisi
            if (data.nomor_surat) {
              this.setState({ printData: data });
            }

            // Muat daftar kabupaten berdasarkan provinsi tersimpan, lalu set nilainya
            if (savedProvinsiId != null) {
              const apiParam = this.resolveProvinsiApiParam(savedProvinsiId);
              this.loadKabupatenAndSetValue(apiParam, savedKabupatenId);
            }

            // onValuesChange tidak terpanggil saat setFieldsValue programatik,
            // evaluasi manual setelah semua field terisi
            this.handleFormChange();
          }
        } else {
          const errTitle = "error preview data";
          this.setState({ errTitle, errMsg: this.props.responseMsg });
          message.error({ content: errTitle, duration: 2, key: "toast" });
        }
        this.setState({ loadingData: false });
      })
      .catch((response) => {
        console.log("gagal_get_preview", response);
        message.error({ content: "gagal request data, coba lagi", duration: 2, key: "toast" });
        this.setState({ loadingData: false });
      });
  }

  async loadKabupatenAndSetValue(provinsiId, kabupatenId) {
    this.setState({ loadingKabupaten: true });
    this.props
      .ajaxViewHandler(
        "get",
        configClass.apiUrl.kabupaten + "?province=" + provinsiId + "&fiskal=true"
      )
      .then(() => {
        const data = this.props.responseMsg;
        if (this.props.isSuccess) {
          const arr = data.results || (Array.isArray(data) ? data : []);
          // Gunakan setState callback agar setFieldsValue dipanggil SETELAH
          // React selesai render dengan opsi baru — Select sudah punya opsi saat nilai di-set
          this.setState({ listKabupaten: arr, loadingKabupaten: false }, () => {
            if (kabupatenId != null && this.formRef.current) {
              this.formRef.current.setFieldsValue({ kabupaten_tujuan: kabupatenId });
            }
          });
        } else {
          this.setState({ loadingKabupaten: false });
        }
      })
      .catch(() => this.setState({ loadingKabupaten: false }));
  }

  // ── Submit & print ───────────────────────────────────────────

  handleFormChange = () => {
    if (!this.formRef.current) return;
    const v = this.formRef.current.getFieldsValue();
    const required = [
      "nomor_surat",
      "kode_tujuan",
      "provinsi_tujuan_nama",
      "kabupaten_tujuan",
      "nama_tujuan",
      "alamat_tujuan",
      "tanggal_fiskal",
    ];
    const allFilled = required.every((f) => v[f] != null && v[f] !== "");
    this.setState({ formAllFilled: allFilled });
  };

  handleSubmit = (values) => {
    this.postDataPenetapan(values);
  };

  reset = () => {
    this.setState({
      cari_no_pol: undefined,
      dataKendaraan: null,
      printData: null,
      kode_tujuan: "1",
      listKabupaten: [],
      errTitle: "",
      errMsg: "",
      formAllFilled: false,
    });
    this.filterAndSetProvinsi("1");
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };

  async postDataPenetapan(datas) {
    message.loading({ content: "Memproses...", duration: 0, key: "toast" });
    this.setState({ errTitle: "", errMsg: "", loadingButton: true });

    this.props
      .ajaxHandler(
        "post",
        configClass.apiUrl.fiskal + this.state.dataKendaraan.id + "/fiskal/",
        datas,
        false,
        true
      )
      .then(() => {
        if (this.props.isSuccess) {
          message.success({ content: "Data Fiskal Berhasil di Simpan", duration: 2, key: "toast" });
          this.setState({ loadingButton: false });

          const id = this.state.dataKendaraan.id;
          // Fetch print data dulu sebelum tampilkan modal
          this.props
            .ajaxViewHandler("get", configClass.apiUrl.fiskal + id + "?is_fiskal=true")
            .then(() => {
              var that = this;
              if (this.props.isSuccess) {
                this.setState({ printData: this.props.responseMsg });
              }
              Modal.confirm({
                title: "Berhasil Menyimpan Fiskal",
                icon: <CheckCircleOutlined style={{ color: "green" }} />,
                content: "Tekan cetak untuk mencetak dokumen, tekan selesai untuk melanjutkan",
                okText: (
                  <span>
                    <PrinterOutlined /> Cetak
                  </span>
                ),
                cancelText: "Selesai",
                onOk() {
                  that.handlePrint();
                  that.reset();
                },
                onCancel() {
                  that.reset();
                },
              });
            })
            .catch(() => {
              var that = this;
              Modal.confirm({
                title: "Berhasil Menyimpan Fiskal",
                icon: <CheckCircleOutlined style={{ color: "green" }} />,
                content: "Data tersimpan. Buka tab baru untuk mencetak?",
                okText: (
                  <a
                    href={configClass.pageUrl.cetak_no + id + "/?is_fiskal=true"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <PrinterOutlined /> Cetak
                  </a>
                ),
                cancelText: "Selesai",
                onOk() { that.reset(); },
                onCancel() { that.reset(); },
              });
            });
        } else {
          const errTitle = "Data Fiskal Gagal Tersimpan";
          message.error({ content: errTitle, duration: 2, key: "toast" });
          this.setState({
            loadingButton: false,
            errTitle,
            errMsg: JSON.stringify(this.props.responseMsg),
          });
        }
      })
      .catch((response) => {
        console.log("gagal_post_fiskal", response);
        this.setState({ loadingButton: false });
        message.error({
          content: "Kesalahan Pengiriman Data Fiskal, coba lagi",
          duration: 2,
          key: "toast",
        });
      });
  }

  handlePrint = () => {
    const printEl = document.querySelector(".skf-print-only");
    if (!printEl) return;
    const parent = printEl.parentNode;
    const nextSib = printEl.nextSibling;
    document.body.appendChild(printEl);
    const siblings = Array.from(document.body.children).filter((el) => el !== printEl);
    siblings.forEach((el) => { el.style.display = "none"; });
    window.print();
    siblings.forEach((el) => { el.style.display = ""; });
    if (nextSib) parent.insertBefore(printEl, nextSib);
    else parent.appendChild(printEl);
  };

  // ── Render print template (sama dengan SuratFiskal.jsx) ─────

  renderPrintContent() {
    const d = this.state.printData;
    if (!d) return null;
    return (
      <div style={{ padding: 20 }}>
        {/* Halaman 1 */}
        <div className="header-surat" style={{ position: "relative" }}>
          <div className="kop-logo">
            <img src={config.get_site_info().logo_bw} alt="Logo" height="90" />
          </div>
          <div className="kop" style={{ fontSize: 20 }}>
            PEMERINTAH PROVINSI KALIMANTAN TENGAH<br />
            BADAN PENDAPATAN DAERAH
          </div>
          <div className="sub-kop" style={{ fontSize: 16 }}>
            UNIT PELAKSANA TEKNIS PELAYANAN PENDAPATAN DAERAH<br />
            DI {d.kabupaten_nama}<br />
          </div>
          <div className="sub-kop2" style={{ fontSize: 12 }}>
            Jalan R.T.A. Milino Km. 5,5 Telp 0536-32275523
          </div>
        </div>

        <div className="judul-surat" style={{ fontSize: 20 }}>
          SURAT KETERANGAN FISKAL ANTAR DAERAH
        </div>
        <div className="nomor-surat" style={{ fontSize: 16 }}>
          NOMOR: {d.nomor_surat}
        </div>

        <div className="isi">
          Kepala Badan Pendapatan Daerah Provinsi Kalimantan Tengah Menerangkan, bahwa kendaraan berikut ini :
          <ol>
            <li><Row><Col span={4}>Nomor Polisi</Col><Col span={20}>: {d.nomor_polisi}</Col></Row></li>
            <li><Row><Col span={4}>Nama Pemilik</Col><Col span={20}>: {d.pemilik_nama}</Col></Row></li>
            <li><Row><Col span={4}>Alamat</Col><Col span={20}>: {d.alamat_wp}</Col></Row></li>
            <li><Row><Col span={4}>Jenis</Col><Col span={20}>: {d.jenis_kendaraan}</Col></Row></li>
            <li><Row><Col span={4}>Tahun / CC</Col><Col span={20}>: {d.tahun_buat + " / " + d.cc}</Col></Row></li>
            <li><Row><Col span={4}>Merk / Tipe</Col><Col span={20}>: {d.merk_kendaraan + " / " + d.tipe_nama}</Col></Row></li>
            <li><Row><Col span={4}>Nomor Rangka</Col><Col span={20}>: {d.nomor_rangka}</Col></Row></li>
            <li><Row><Col span={4}>Nomor Mesin</Col><Col span={20}>: {d.nomor_mesin}</Col></Row></li>
            <li><Row><Col span={4}>Plat Dasar</Col><Col span={20}>: {d.warna_plat_nama}</Col></Row></li>
            <li><Row><Col span={4}>Warna</Col><Col span={20}>: {d.warna}</Col></Row></li>
          </ol>
        </div>

        <div className="berdasarkan">Berdasarkan catatan kami telah melunasi :</div>
        <table border={1}>
          <tbody>
            <tr>
              <td>
                <Row>
                  <Col span={4}>- PKB sebesar</Col>
                  <Col span={4}>Rp. {d.jumlah_pokok ? d.jumlah_pokok.toLocaleString("in") : 0}</Col>
                  <Col span={4}>Tgl. {moment(d.tgl_penetapan).format("DD-MM-YYYY")}</Col>
                  <Col span={4}>No. Kohir</Col>
                  <Col span={8}>{d.no_kohir}</Col>
                </Row>
              </td>
            </tr>
            <tr>
              <td>
                <Row>
                  <Col span={4}>- BBNKB sebesar</Col>
                  <Col span={4}>Rp. {d.jumlah_bbnkb ? d.jumlah_bbnkb.toLocaleString("in") : 0}</Col>
                  <Col span={4}>Tgl. {moment(d.tgl_penetapan).format("DD-MM-YYYY")}</Col>
                  <Col span={4}>No. Skum</Col>
                  <Col span={8}>{d.no_skum}</Col>
                </Row>
              </td>
            </tr>
            <tr>
              <td>
                <Row>
                  <Col span={8}>Masa Pajak berlaku sampai dengan tanggal</Col>
                  <Col span={16}>{d.masa_pajak_sampai}</Col>
                </Row>
              </td>
            </tr>
          </tbody>
        </table>

        Keterangan ini di berikan berhubungan kendaraan tersebut akan dipindahkan ke Daerah tujuan : {d.kabupaten_tujuan_nama}

        <div className="biodata-fiskal">
          <Row>
            <Col span={4} className="titik-dua">Untuk Atas Nama</Col>
            <Col span={20}>{d.nama_tujuan}</Col>
            <Col span={4} className="titik-dua">Alamat Pemilik</Col>
            <Col span={20}>{d.alamat_tujuan}</Col>
          </Row>
        </div>

        Demikian untuk dipergunakan sebagaimana mestinya

        <Row justify="end pagebreak">
          <Col span={10} className="ttd-fiskal">
            {d.kabupaten_nama}, {moment(d.tanggal_fiskal).format("DD MMMM YYYY").toUpperCase()}<br />
            <b>
              An. KEPALA BADAN PENDAPATAN DAERAH<br />
              PROVINSI KALIMANTAN TENGAH<br />
              KASI PENETAPAN DAN PENERIMAAN<br />
              DI {d.kabupaten_nama}
            </b>
            <div className="nama-ttd-fiskal">{d.korektor_nama}</div>
            <div className="nip-ttd-fiskal">NIP. {d.korektor_nip}</div>
          </Col>
        </Row>

        {/* Halaman 2 — Daftar Pengantar */}
        <div className="pagebreak">
          <div className="header-surat" style={{ position: "relative" }}>
            <div className="kop-logo">
              <img src={config.get_site_info().logo_bw} alt="Logo" height="90" />
            </div>
            <div className="kop" style={{ fontSize: 20 }}>
              PEMERINTAH PROVINSI KALIMANTAN TENGAH<br />
              BADAN PENDAPATAN DAERAH
            </div>
            <div className="sub-kop" style={{ fontSize: 16 }}>
              UNIT PELAKSANA TEKNIS PELAYANAN PENDAPATAN DAERAH<br />
              DI {d.kabupaten_nama}<br />
            </div>
            <div className="sub-kop2" style={{ fontSize: 12 }}>
              Jalan R.T.A. Milino Km. 5,5 Telp 0536-32275523
            </div>
          </div>
          <Row justify="space-between">
            <Col span={11}>{"Nomor : " + d.nomor_surat}</Col>
            <Col span={2}>Kepada<br />Yth. Sdr.</Col>
            <Col span={11}>
              Kepala Badan / Kepala Unit Pelaksana Teknis Pendapatan<br />
              Provinsi {d.provinsi_tujuan_nama}<br />
              di {d.kabupaten_tujuan_nama}
            </Col>
            <Col span={24} style={{ textAlign: "center", fontSize: 18, marginTop: 10, marginBottom: 5, fontWeight: "bold" }}>
              DAFTAR PENGANTAR
            </Col>
            <Col span={24}>
              <table border={1} cellPadding="5">
                <tbody>
                  <tr>
                    <td>No</td>
                    <td>Jenis Yang Dikirim</td>
                    <td>Banyaknya</td>
                    <td>Keterangan</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td valign="top">
                      Bersama ini kami kirimkan :<br /><br />
                      Tindasan Surat Keterangan Fiskal bagi Kendaraan yang dimutasikan ke Unit Pelaksana Teknis Dinas Pendapatan Provinsi {d.provinsi_tujuan_nama} di {d.kabupaten_tujuan_nama}
                    </td>
                    <td valign="top">berkas</td>
                    <td valign="top">Dikirim dengan hormat untuk dipergunakan sebagaimana mestinya</td>
                  </tr>
                </tbody>
              </table>
            </Col>
            <Col span={5}>
              Diterima tanggal, .......<br />Yang Menerima
            </Col>
            <Col span={19} style={{ textAlign: "right" }}>
              <div style={{ textAlign: "center" }}>
                {d.kabupaten_nama}, {moment(d.tanggal_fiskal).format("DD MMMM YYYY").toUpperCase()}<br />
                <b>
                  KASI PENETAPAN DAN PENERIMAAN DI {d.kabupaten_nama}<br />
                  BADAN PENDAPATAN DAERAH PROV. KALIMANTAN TENGAH<br />
                </b>
                <div className="nama-ttd-fiskal">{d.korektor_nama}</div>
                <div className="nip-ttd-fiskal">NIP. {d.korektor_nip}</div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  // ── Render ───────────────────────────────────────────────────

  render() {
    const { dataKendaraan, loadingData, loadingButton, errTitle, errMsg, kode_tujuan } = this.state;

    const NAVY = "#0f2847";
    const NAVY_MID = "#1a3a6b";

    const lbl = (txt) => (
      <span style={{ fontSize: 11, fontWeight: 600, color: "#475569", textTransform: "uppercase", letterSpacing: 0.5 }}>
        {txt}
      </span>
    );

    const InfoItem = ({ label, value, span = 12 }) => (
      <Col xs={24} sm={span}>
        <div style={{ marginBottom: 10 }}>
          <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 3 }}>
            {label}
          </div>
          <div style={{ fontSize: 13, color: "#1e293b", fontWeight: 500, background: "#fff", padding: "6px 10px", borderRadius: 8, border: "1px solid #e2e8f0", minHeight: 32, lineHeight: "20px" }}>
            {value || <span style={{ color: "#cbd5e1" }}>-</span>}
          </div>
        </div>
      </Col>
    );

    return (
      <div>
        <Helmet>
          <title>{configClass.title + " | " + config.get_site_info().name}</title>
        </Helmet>


        <div className="card">
          <Row className="isi" gutter={[0, 14]}>
            <Col span={24}>
              <div style={{ background: "#fff", borderRadius: 14, overflow: "hidden", border: "1px solid #e2e8f0", boxShadow: "0 2px 12px rgba(15,40,71,0.07)" }}>

                {/* ── Header dark navy ── */}
                <div style={{ background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_MID} 100%)`, padding: "16px 20px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <div style={{ width: 36, height: 36, background: "rgba(251,191,36,0.15)", borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>
                      📋
                    </div>
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 700, color: "#fff", letterSpacing: 0.3 }}>
                        Surat Keterangan Fiskal
                      </div>
                      <div style={{ fontSize: 11, color: "#64748b" }}>
                        Cari kendaraan berdasarkan nomor polisi untuk menerbitkan surat fiskal
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ padding: "20px 24px" }}>

                  {/* Error */}
                  <ErrorAlertModal
                    visible={errTitle !== ""}
                    title={errTitle}
                    error={errMsg}
                    onClose={() => this.setState({ errTitle: '', errMsg: '' })}
                  />

                  {/* ── Search bar ── */}
                  <div style={{ marginBottom: 20 }}>
                    {lbl("Nomor Polisi Kendaraan")}
                    <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 8, flexWrap: "wrap" }}>
                      <div style={{ display: "flex", flex: "1 1 280px", maxWidth: 400, border: "1px solid #d1d5db", borderRadius: 9, overflow: "hidden", background: "#f8fafc" }}>
                        <div style={{ padding: "0 14px", display: "flex", alignItems: "center", background: "#e2e8f0", borderRight: "1px solid #d1d5db", fontSize: 13, fontWeight: 700, color: "#475569", flexShrink: 0 }}>
                          KH
                        </div>
                        <Input
                          bordered={false}
                          placeholder="1234XY"
                          value={this.state.cari_no_pol}
                          style={{ flex: 1, background: "transparent", fontSize: 14 }}
                          onChange={(e) => this.setState({ cari_no_pol: e.target.value })}
                          onKeyPress={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              this.searchKendaraan(this.state.cari_no_pol);
                            }
                          }}
                        />
                      </div>
                      <Button
                        type="primary"
                        loading={loadingData}
                        icon={!loadingData ? <SearchOutlined /> : null}
                        onClick={() => this.searchKendaraan(this.state.cari_no_pol)}
                        style={{ borderRadius: 9, height: 36, paddingInline: 20, fontWeight: 700, background: NAVY, borderColor: NAVY, flexShrink: 0 }}
                      >
                        Cari Kendaraan
                      </Button>
                      {this.state.formAllFilled && this.state.printData != null && (
                        <Button
                          type="default"
                          icon={<PrinterOutlined />}
                          onClick={this.handlePrint}
                          style={{ borderRadius: 9, height: 36, paddingInline: 20, fontWeight: 600, flexShrink: 0 }}
                        >
                          Cetak
                        </Button>
                      )}
                    </div>
                  </div>

                  {/* Loading search */}
                  {loadingData && (
                    <div style={{ textAlign: "center", padding: "30px 0" }}>
                      <Spin size="large" />
                      <div style={{ marginTop: 12, color: "#64748b", fontSize: 13 }}>Mencari kendaraan...</div>
                    </div>
                  )}

                  {/* Empty state */}
                  {!dataKendaraan && !loadingData && (
                    <div style={{ textAlign: "center", padding: "40px 0", color: "#94a3b8" }}>
                      <div style={{ fontSize: 48, marginBottom: 12 }}>🚗</div>
                      <div style={{ fontSize: 13, fontWeight: 500 }}>Masukkan nomor polisi untuk mencari kendaraan</div>
                      <div style={{ fontSize: 11, marginTop: 4 }}>Contoh: KH1234XY</div>
                    </div>
                  )}

                  {/* ── Kendaraan found ── */}
                  {dataKendaraan != null && (
                    <>
                      <Divider style={{ margin: "4px 0 16px" }}>
                        <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 600 }}>🚗 INFO KENDARAAN</span>
                      </Divider>

                      <div style={{ background: "#f8fafc", borderRadius: 12, padding: "16px", border: "1px solid #e2e8f0", marginBottom: 20 }}>
                        <Row gutter={[12, 0]}>
                          <InfoItem label="No. Polisi" value={dataKendaraan.nomor_polisi} span={8} />
                          <InfoItem label="Nama Pemilik" value={dataKendaraan.pemilik_nama} span={16} />
                          <InfoItem label="Alamat" value={dataKendaraan.alamat_wp} span={24} />
                          <InfoItem label="Jenis Kendaraan" value={dataKendaraan.jenis_kendaraan} span={8} />
                          <InfoItem label="Tahun / CC" value={`${dataKendaraan.tahun_buat || "-"} / ${dataKendaraan.cc || "-"}`} span={8} />
                          <InfoItem label="Bahan Bakar" value={dataKendaraan.bahan_bakar_nama} span={8} />
                          <InfoItem label="Merek" value={dataKendaraan.merk_kendaraan} span={8} />
                          <InfoItem label="Tipe" value={dataKendaraan.tipe_nama} span={8} />
                          <InfoItem label="Warna" value={dataKendaraan.warna} span={8} />
                          <InfoItem label="No. Rangka" value={dataKendaraan.nomor_rangka} span={12} />
                          <InfoItem label="No. Mesin" value={dataKendaraan.nomor_mesin} span={12} />
                        </Row>
                      </div>

                      <Divider style={{ margin: "0 0 16px" }}>
                        <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 600 }}>📄 DATA FISKAL</span>
                      </Divider>

                      <Alert
                        message="Keterangan ini diberikan berhubung kendaraan tersebut akan dipindahkan ke daerah tujuan"
                        type="info"
                        showIcon
                        style={{ marginBottom: 20, borderRadius: 8 }}
                      />

                      <Form
                        layout="vertical"
                        name="fdata"
                        onFinish={this.handleSubmit}
                        onValuesChange={this.handleFormChange}
                        size="small"
                        ref={this.formRef}
                        initialValues={{ kode_tujuan: "1", no_polisi_depan: "KH" }}
                        disabled={loadingButton}
                      >
                        <Form.Item name="no_polisi_depan" style={{ display: "none" }}>
                          <Input type="hidden" />
                        </Form.Item>

                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: "0 16px" }}>

                          <Form.Item
                            name="nomor_surat"
                            label={lbl("No. Surat")}
                            style={{ marginBottom: 14 }}
                            rules={[{ required: true, message: "harus diisi" }]}
                          >
                            <Input placeholder="Input nomor surat" style={{ borderRadius: 8 }} autoFocus />
                          </Form.Item>

                          <Form.Item
                            name="kode_tujuan"
                            label={lbl("Kode Tujuan")}
                            style={{ marginBottom: 14 }}
                            rules={[{ required: true, message: "harus diisi" }]}
                          >
                            <Select
                              placeholder="Pilih kode tujuan"
                              allowClear
                              onChange={this.handleKodeTujuanChange}
                              style={{ width: "100%" }}
                            >
                              <Select.Option value="1">1 — Antar Provinsi</Select.Option>
                              <Select.Option value="2">2 — Dalam Provinsi</Select.Option>
                            </Select>
                          </Form.Item>

                          <Form.Item
                            name="provinsi_tujuan_nama"
                            label={lbl("Provinsi Tujuan")}
                            style={{ marginBottom: 14 }}
                            rules={[{ required: true, message: "harus diisi" }]}
                          >
                            <Select
                              showSearch
                              placeholder={kode_tujuan === "2" ? "Kalimantan Tengah (otomatis)" : "Cari / Pilih Provinsi"}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option && option.children &&
                                option.children.toLowerCase().includes(input.toLowerCase())
                              }
                              allowClear={kode_tujuan !== "2"}
                              loading={this.state.loadingProvinsi}
                              disabled={kode_tujuan === "2"}
                              onChange={this.handleProvinsiChange}
                              style={{ width: "100%" }}
                            >
                              {this.state.listProvinsi.map((item) => (
                                <Select.Option key={item.id} value={item.id}>
                                  {item.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>

                          <Form.Item
                            name="kabupaten_tujuan"
                            label={lbl("Kabupaten / Kota Tujuan")}
                            style={{ marginBottom: 14 }}
                            rules={[{ required: true, message: "harus diisi" }]}
                          >
                            {this.generateKabupatenSelect()}
                          </Form.Item>

                          <Form.Item
                            name="nama_tujuan"
                            label={lbl("Nama Pemilik Baru")}
                            style={{ marginBottom: 14 }}
                            rules={[{ required: true, message: "harus diisi" }]}
                          >
                            <Input placeholder="Input nama" style={{ borderRadius: 8 }} />
                          </Form.Item>

                          <Form.Item
                            name="alamat_tujuan"
                            label={lbl("Alamat Tujuan")}
                            style={{ marginBottom: 14 }}
                            rules={[{ required: true, message: "harus diisi" }]}
                          >
                            <Input placeholder="Input alamat tujuan" style={{ borderRadius: 8 }} />
                          </Form.Item>

                          <Form.Item
                            name="tanggal_fiskal_picker"
                            label={lbl("Tanggal Fiskal")}
                            style={{ marginBottom: 14 }}
                            rules={[{ required: true, message: "harus diisi" }]}
                          >
                            <DatePicker
                              placeholder="dd-mm-yyyy"
                              format="DD-MM-YYYY"
                              style={{ width: "100%", borderRadius: 8 }}
                              onChange={(date, dateString) => {
                                this.formRef.current.setFieldsValue({ tanggal_fiskal: dateString });
                              }}
                            />
                          </Form.Item>

                        </div>

                        <Form.Item name="tanggal_fiskal" style={{ display: "none" }}>
                          <Input type="hidden" />
                        </Form.Item>

                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, paddingTop: 8, borderTop: "1px solid #f1f5f9" }}>
                          <Button
                            type="primary"
                            htmlType="submit"
                            loading={loadingButton}
                            icon={!loadingButton ? <CheckCircleOutlined /> : null}
                            style={{ borderRadius: 9, height: 36, paddingInline: 24, fontWeight: 700, background: NAVY, borderColor: NAVY }}
                          >
                            Simpan Fiskal
                          </Button>
                        </div>
                      </Form>
                    </>
                  )}

                </div>
              </div>
            </Col>
          </Row>
        </div>

        {/* ── Print-only section ── */}
        <div className="skf-print-only">
          {this.renderPrintContent()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return state.configReducers;
};

export default connect(mapStateToProps, {
  initHandler,
  setConfig,
  ajaxViewHandler,
  ajaxHandler,
})(SuratKeteranganFiskal);
